export default __webpack_public_path__ + "static/media/verfication_envelop.f4f6ef65.svg";